var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"agrupamento"}},[_c('div',{staticClass:"header"},[_c('h5',[_vm._v(_vm._s(_vm.cliente.nome))])]),_c('div',{staticClass:"body"},_vm._l((_vm.cliente.cprs),function(cpr){return _c('div',{key:cpr.id,staticClass:"resultados"},[_c('resultado-pesquisa-accordion',{attrs:{"cpr":cpr}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }